<template>
  <SelectList
    v-model="selectedValue"
    :clearable="clearable"
    :dense="dense"
    :emit-value="emitValue"
    :filled="filled"
    :filter-method="filter"
    :hint="hint"
    :input-debounce="300"
    :label="label"
    :no-options-message="noOptionsMessage"
    :option-label="labelForUser"
    option-value="id"
    :options="options"
    :rules="rules"
  />
</template>

<script>
import { User } from "shared/resources";

import SelectList from "src/components/common/SelectList.vue";

export default {
  name: "AllUserDropdown",
  components: {
    SelectList,
  },
  props: {
    modelValue: {
      type: [Number, String, Object],
      default: null,
    },
    label: {
      type: String,
      default: "User",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    defaultValue: {
      type: Object,
      default: () => ({}),
    },
    clearable: {
      type: Boolean,
    },
    organisationId: {
      type: [Number, String],
      default: null,
    },
    includeInactive: {
      type: Boolean,
    },
    filled: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    },
    dense: {
      type: Boolean,
    },
    emitValue: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    },
    hideOrganisation: {
      type: Boolean,
    },
    hint: {
      type: String,
      default: null,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      options: [],
      query: "",
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    noOptionsMessage() {
      return this.query ? "" : "Start typing to search";
    },
  },
  watch: {
    defaultValue: {
      immediate: true,
      handler() {
        if (this.defaultValue.id) {
          this.options = [this.defaultValue];
        }
      },
    },
  },
  methods: {
    labelForUser(user) {
      let label = `#${user.id} ${user.name}`;

      if (
        !this.hideOrganisation &&
        (user.organisation || user.organisation_name)
      ) {
        label = `${label} (${
          user.organisation ? user.organisation.name : user.organisation_name
        })`;
      }

      return label;
    },
    filter(query) {
      this.query = query;
      if (!query) return [];

      const where = {
        details: { match: query },
        organisationId: this.organisationId,
      };

      if (!this.includeInactive) where.active = true;

      return new Promise((resolve) => {
        User.where(where)
          .includes("organisation")
          .select({ organisations: ["name"], users: ["name", "email"] })
          .per(10)
          .all()
          .then((response) => {
            resolve(response.data);
          });
      });
    },
  },
};
</script>
